<div class="routed-container">
  <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
    <div class="flex gap-2 items-center w-100">
      <a [routerLink]="['/employees']" class="back-button flex items-center justify-center gap-2 no-decoration">
        <i class="material-icons">arrow_back</i>
        <span>Back</span>
      </a>
      <h2 class="w-70 center-text">Employee Details</h2>
    </div>
    <!-- Employee Details-->
    <ng-container *ngIf="loadingEmployee; else employeeDetails">
      <div class="loader">
        <mat-spinner color="warn" [diameter]="50"></mat-spinner>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #employeeDetails>
  <div *ngIf="selectedEmployee == null" class="flex flex-col items-center justify-center">
    <h3>{{ errorMessage }}</h3>
    <p class="center-text text-muted">Employee ID: {{ empid }}</p>
  </div>
  <section id="employee-details" class="w-100" *ngIf="selectedEmployee !== null">
    <div class="flex card">
      <div class="flex justify-between items-center w-100">
        <div class="flex gap-2">
          <img [src]="selectedEmployee.profile_img" class="profile-picture" />
          <div class="flex flex-col justify-center gap-2">
            <h2 class="no-m">
              {{ selectedEmployee.first_name }} {{ selectedEmployee.last_name }}
            </h2>
            <p class="no-m md-text">
              Legal Name: {{ selectedEmployee.legal_first_name }}
              {{ selectedEmployee.legal_last_name }}
            </p>
            <p class="no-m">File Number: {{ selectedEmployee.file_number }}</p>
          </div>
        </div>
        <button class="edit-button" (click)="showEditBasicInfo()">
          Edit
        </button>
      </div>
    </div>

    <div class="card lg-mt">
      <div class="header-info">
        <h3>Contact Information</h3>
        <button class="edit-button" (click)="showEditInfo()">
          Edit
        </button>
      </div>
      <div class="list-container">
        <div class="list-item">
          <strong>Phone Number</strong>
          <p>
            {{ selectedEmployee.phone ? selectedEmployee.phone : "&mdash;" }}
          </p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Email Address</strong>
          <p>{{ selectedEmployee.email }}</p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Address</strong>
          <p>{{ fullAddress() }}</p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Coordinates</strong>
          <p>
            {{ selectedEmployee.latitude ? selectedEmployee.latitude : "--" }},
            {{ selectedEmployee.longitude ? selectedEmployee.longitude : "--" }}
          </p>
          <span class="spacer"></span>
        </div>
      </div>

      <div class="header-info">
        <h3>Worker Information</h3>
        <button class="edit-button" (click)="showEditWorkerInfo()">
          Edit
        </button>
      </div>

      <div class="list-container">
        <div class="list-item">
          <strong>Worker Type</strong>
          <p>{{ selectedEmployee.contractor ? "Contractor" : "Employee" }}</p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Paperwork</strong>
          <p class="flex items-center gap-2">
            <i class="material-icons text-red" *ngIf="!selectedEmployee.paperwork">cancel</i>
            <i class="material-icons text-green-400" *ngIf="selectedEmployee.paperwork">check_circle</i>

            <span>{{
              selectedEmployee.paperwork ? "Signed" : "Unsigned"
              }}</span>
          </p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Paperwork Needs Update?</strong>
          <p>{{ selectedEmployee.waiting_on_new_paperwork ? "Yes" : "No" }}</p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Status</strong>
          <p class="flex items-center gap-2">
            <i class="material-icons text-green-400" *ngIf="selectedEmployee.active">check_circle</i>
            <i class="material-icons text-gray" *ngIf="!selectedEmployee.active">remove_circle</i>
            <span>{{ selectedEmployee.active ? "Active" : "Inactive" }}</span>
          </p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Position</strong>
          <p>{{ selectedEmployee.employee_type }}</p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Quizmaster Rate</strong>
          <p>${{ selectedEmployee.QM_rate }}</p>
          <span class="spacer"></span>
        </div>

        <div class="list-item">
          <strong>Hourly Rate</strong>
          <p>${{ selectedEmployee.hourly_rate }}</p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Can Host Online</strong>
          <p>
            <i class="material-icons text-gray" *ngIf="!selectedEmployee.can_host_online">cancel</i>
            <i class="material-icons text-green-400" *ngIf="selectedEmployee.can_host_online">check_circle</i>
          </p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Can Host Pub Quiz</strong>
          <p>
            <i class="material-icons text-gray" *ngIf="!selectedEmployee.can_host_trivia">cancel</i>
            <i class="material-icons text-green-400" *ngIf="selectedEmployee.can_host_trivia">check_circle</i>
          </p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Can Host Survey Slam</strong>
          <p>
            <i class="material-icons text-gray" *ngIf="!selectedEmployee.can_host_ss">cancel</i>
            <i class="material-icons text-green-400" *ngIf="selectedEmployee.can_host_ss">check_circle</i>
          </p>
          <span class="spacer"></span>
        </div>
        <div class="list-item">
          <strong>Can Host Bingo</strong>
          <p>
            <i class="material-icons text-gray" *ngIf="!selectedEmployee.can_host_bingo">cancel</i>
            <i class="material-icons text-green-400" *ngIf="selectedEmployee.can_host_bingo">check_circle</i>
          </p>
          <span class="spacer"></span>
        </div>
      </div>

      <div class="header-info">
        <h3>Security</h3>
      </div>

      <div *ngIf="selectedEmployee.employee_type !== 'Office Staff'" class="list-container">
        <div class="list-item">
          <strong>Password</strong>
          <p>
            <button class="edit-button" (click)="showChangePasswordModal = true">Change Password</button>
          </p>
          <span class="spacer"></span>
        </div>
      </div>
    </div>
  </section>
</ng-template>

<!-- TEMPLATES -->
<ng-template #changePasswordModalContent>
  <div class="input-group">

    <div class="flex flex-col gap-2">
      <div class="flex gap-2 items-center">
        <input type="text" [(ngModel)]="employeeNewPassword" id="new-password" class="textbox w-100"
          placeholder="Enter new password" /> <i class="material-icons text-gray clickable copy-button"
          title="Copy" (click)="copyPassword()">content_copy</i>
      </div>
      <small (click)="generatePassword()" class="clickable text-info">Generate Random Password</small>
    </div>
  </div>
   <div class="input-group">
    <label for="sendemail">
      <input type="checkbox" [(ngModel)]="sendPasswordEmail" id="sendemail" class="textbox p-10" />
      Send Password to Employee</label>
  </div>
  <p *ngIf="successMessage !== ''" class="success-message">{{ successMessage }}</p>
  <p *ngIf="errorMessage !== ''" class="error-message">{{ errorMessage }}</p>

</ng-template>

<ng-template #editInfoModalContent>
  <div class="input-group">
    <label for="phone">Phone Number</label>
    <input type="text" [maxlength]="13" [(ngModel)]="editableEmployee.phone" id="phone" class="textbox p-10" />
  </div>

  <div class="label-divider">
    <span class="divider-line"></span>
    <p class="label">Address</p>
    <span class="divider-line"></span>
  </div>

  <div class="input-group">
    <label for="address_1">Address Line 1</label>
    <input type="text" [(ngModel)]="editableEmployee.address_1" id="address_1" class="textbox p-10" />
  </div>

  <div class="input-group">
    <label for="address_2">Address Line 2</label>
    <input type="text" [(ngModel)]="editableEmployee.address_2" id="address_2" class="textbox p-10" />
  </div>

  <div class="input-group">
    <label for="city">City</label>
    <input type="text" [(ngModel)]="editableEmployee.city" id="city" class="textbox p-10" />
  </div>

  <div class="flex gap-2">
    <div class="input-group">
      <label for="state">State</label>
      <input type="text" [maxlength]="2" [(ngModel)]="editableEmployee.state" id="state" class="textbox p-10" />
    </div>
    <div class="input-group">
      <label for="zip">ZIP Code</label>
      <input type="tel" [(ngModel)]="editableEmployee.zip_code" id="zip" class="textbox p-10 w-100" />
    </div>
  </div>

   <p *ngIf="successMessage !== ''" class="success-message">{{ successMessage }}</p>
   <p *ngIf="errorMessage !== ''" class="error-message">{{ errorMessage }}</p>
</ng-template>

<ng-template #editWorkerInfoModalContent>
  <div class="input-group">
    <label for="contractor">Worker Type</label>
    <select class="textbox p-10" id="contractor" [(ngModel)]="editableEmployee.contractor">
      <option [ngValue]="false">Employee</option>
      <option [ngValue]="true">Contractor</option>
    </select>
  </div>

  <div class="input-group">
    <label for="paperwork">Paperwork Status</label>
    <select class="textbox p-10" id="paperwork" [(ngModel)]="editableEmployee.paperwork">
      <option [ngValue]="false">Waiting for Signature</option>
      <option [ngValue]="true">Signed</option>
    </select>
  </div>

  <div class="input-group">
    <label for="waiting_on_new_paperwork">Paper works needs update?</label>
    <select class="textbox p-10" id="waiting_on_new_paperwork" [(ngModel)]="editableEmployee.waiting_on_new_paperwork">
      <option [ngValue]="false">No</option>
      <option [ngValue]="true">Yes</option>
    </select>
  </div>

  <div class="input-group">
    <label for="status">Worker Status</label>
    <select class="textbox p-10" id="status" [(ngModel)]="editableEmployee.active">
      <option [ngValue]="false">Inactive</option>
      <option [ngValue]="true">Active</option>
    </select>
  </div>

  <div class="input-group">
    <label for="position">Position</label>
    <select class="textbox p-10" id="position" [(ngModel)]="editableEmployee.employee_type">
      <option value="Quizmaster">Quizmaster</option>
      <option value="Writer">Writer</option>
      <option value="Office">Office Staff</option>
    </select>
  </div>

  <div class="label-divider">
    <span class="divider-line"></span>
    <p class="label">Rates</p>
    <span class="divider-line"></span>
  </div>

  <div class="input-group">
    <label for="qmrate">Quizmaster Rate</label>
    <input type="number" [(ngModel)]="editableEmployee.QM_rate" id="qmrate" class="textbox p-10" />
  </div>

  <div class="input-group">
    <label for="hourlyrate">Hourly Rate</label>
    <input type="number" [(ngModel)]="editableEmployee.hourly_rate" id="hourlyrate" class="textbox p-10" />
  </div>

  <div class="label-divider">
    <span class="divider-line"></span>
    <p class="label">Hosting Capabilities</p>
    <span class="divider-line"></span>
  </div>

  <div class="input-group">
    <label for="online">
      <input type="checkbox" [(ngModel)]="editableEmployee.can_host_online" id="online" class="textbox p-10" />
      Can Host Online?</label>
  </div>
  <div class="input-group">
    <label for="trivia">
      <input type="checkbox" [(ngModel)]="editableEmployee.can_host_trivia" id="trivia" class="textbox p-10" />
      Can Host Pub Quiz?</label>
  </div>

  <div class="input-group">
    <label for="slam">
      <input type="checkbox" [(ngModel)]="editableEmployee.can_host_ss" id="slam" class="textbox p-10" />
      Can Host Survey Slam?</label>
  </div>
  <div class="input-group">
    <label for="bingo">
      <input type="checkbox" [(ngModel)]="editableEmployee.can_host_bingo" id="bingo" class="textbox p-10" />
      Can Host Bingo?
    </label>
  </div>

    <p *ngIf="successMessage !== ''" class="success-message">{{ successMessage }}</p>
    <p *ngIf="errorMessage !== ''" class="error-message">{{ errorMessage }}</p>
</ng-template>

<ng-template #editBasicInfoModalContent>
  <div class="input-group">
    <label for="fname">First Name</label>
    <input type="text" [(ngModel)]="editableEmployee.first_name" id="fname" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="lname">Last Name</label>
    <input type="text" [(ngModel)]="editableEmployee.last_name" id="lname" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="legal_fn">Legal First Name</label>
    <input type="text" [(ngModel)]="editableEmployee.legal_first_name" id="legal_fn" class="textbox p-10" />
  </div>

  <div class="input-group">
    <label for="legal_ln">Legal Last Name</label>
    <input type="text" [(ngModel)]="editableEmployee.legal_last_name" id="legal_ln" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="fileno">File number</label>
    <input type="number" [(ngModel)]="editableEmployee.file_number" id="fileno" class="textbox p-10" />
  </div>
    <p *ngIf="successMessage !== ''" class="success-message">{{ successMessage }}</p>
    <p *ngIf="errorMessage !== ''" class="error-message">{{ errorMessage }}</p>
</ng-template>

<!-- BASIC INFO MODAL -->
<app-basic-modal *ngIf="showEditBasicInfoModal" [template]="editBasicInfoModalContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Basic Information'" [cancel]="'Close'"
  (doCancel)="showEditBasicInfoModal = false" [action]="isSavingInfo ? 'Saving...' : 'Save'"
  (doAction)="saveBasicInfo()" [disabled]="disabledSaveButton">
</app-basic-modal>

<!-- CONTACT INFO MODAL -->
<app-basic-modal *ngIf="showEditInfoModal" [template]="editInfoModalContent" [hideX]="true" [staticBackground]="false"
  [title]="'Edit Contact Information'" [cancel]="'Close'" (doCancel)="showEditInfoModal = false"
  [action]="isSavingInfo ? 'Saving...' : 'Save'" (doAction)="saveContactInfo()" [disabled]="disabledSaveButton">
</app-basic-modal>

<!-- WORKER INFO MODAL -->
<app-basic-modal *ngIf="showEditWorkerInfoModal" [template]="editWorkerInfoModalContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Worker Information'" [cancel]="'Close'"
  (doCancel)="showEditWorkerInfoModal = false" [action]="isSavingInfo ? 'Saving...' : 'Save'"
  (doAction)="saveWorkerInfo()" [disabled]="disabledSaveButton">
</app-basic-modal>

<!-- CHANGE PASSWORD MODAL -->
<app-basic-modal *ngIf="showChangePasswordModal" [template]="changePasswordModalContent" [hideX]="true"
  [staticBackground]="false" [title]="'Update Employee Password'" [cancel]="'Close'"
  (doCancel)="showChangePasswordModal = false" [action]="isSavingInfo ? 'Updating...' : 'Save'"
  (doAction)="saveNewPassword()" [disabled]="disabledSaveButton">
</app-basic-modal>
